// import React, { useEffect } from 'react';
// import './App.css';
// import Header from './components/Header';
// import HeroSection from './components/HeroSection';
// import AboutSection from './components/AboutSection';
// import ServicesSection from './components/ServicesSection';
// import ContactSection from './components/ContactSection';
// import Footer from './components/Footer';
// import './i18n'; // Importez le fichier de configuration i18n

// function App() {


//   return (
//     <div className="App">
//       {/* <Header />
//       <HeroSection />
//       <AboutSection />
//       <ServicesSection />
//       <ContactSection />
//       <Footer /> */}
//     </div>
//   );
// }

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';  // Importation des composants nécessaires pour le routage
import Page from './components/Page';  // Page d'accueil (à créer)
import { useTranslation } from 'react-i18next';

function App() {
  const { t } = useTranslation();

  return (
    <Router>
      {/* Routes pour la navigation */}
      <Routes>
        {/* <Route path="/" element={<Home />} />  */}
        <Route path="/" element={<Page />} />  {/* Page d'accueil */}
        {/* <Route path="/login" element={<LoginPage />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
